var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.handleClose}},[_c('Header',{attrs:{"isClose":_vm.close}}),_vm._v(" "),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('Footer'),_vm._v(" "),_c('Gotop',{attrs:{"showQrcode":_vm.pathName=='detail',"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }